export function filterValidTaskIds<T extends { task_ids?: string[] }>(
  document: T,
): T {
  return {
    ...document,
    task_ids: document.task_ids?.filter((taskId) => taskId && taskId !== 'none') ?? [],
  };
}
